import React from "react";
import {graphql} from "gatsby";
import parse from "html-react-parser";
import StructuredText from "../custom-structured-text-renderer";
import {Link, Asset, MediaItem} from "../../../../plugins/gatsby-plugin-atollon";
import AnimationButton from "./animation-button";
import { MeatSmithXBoneRoaster } from "../../icons";


const TitleContentVideoItem = ({title, richContent, video, videoEmbed, buttons, icon, tripleIcon, items, theme, paddingBottom, special}) => {
    return (
        <section className={`tcvi tcvi--ambassadors ${theme} ${paddingBottom ? 'tcvi--padding-bottom' : ''}${special ? ' special' : ''}${tripleIcon ? ' tcvi--triple-icon' : ''}`}>
          <div className='tcvi__badge--ambassadors'>
            <MeatSmithXBoneRoaster/>
          </div>
          <div className='tcvi__inner'>
              <div className='tcvi__content' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                  {title && <h2>{parse(title)}</h2>}
                  {richContent && <StructuredText data={richContent}/>}
                  {buttons?.length > 0 &&
                      <AnimationButton className={`btn btn--animation`}
                            to={buttons[0].link[0].externalLink ? buttons[0].link[0].externalLink : buttons[0].link[0].internalLink?.permalink}>
                          {buttons[0].title}
                      </AnimationButton>}
              </div>

              <div className='tcvi__video' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                  {(theme === 'bone' || theme === 'woods') && icon && <span className='badge'><Asset asset={icon}/></span>}
                  {video && !videoEmbed && <video src={video} autoPlay loop muted playsInline/>}
                  {videoEmbed && <MediaItem item={videoEmbed} videoThumbnail={video ? video : null}/> }
              </div>

              <div className='tcvi__items'>
                  {
                      items?.length > 0 && items.map((el, i) => (
                          <div key={i} className='tcvi__item' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                              {el.title && <h3>{el.title}</h3>}
                              {el.richContent && <StructuredText data={el.richContent}/>}
                          </div>
                      ))
                  }
              </div>
          </div>
        </section>
    )
}

export default TitleContentVideoItem

export const query = graphql`
fragment TitleContentVideoItemProps on DatoCmsTitleContentVideoItem {
  ... on DatoCmsTitleContentVideoItem {
    id
    video
    videoEmbed {
      ...MediaItemProps
    }
    title
    richContent {
      value
    }
    paddingBottom
    icon {
      ...InternalAssetProps
    }
    tripleIcon
    buttons {
      ...LinkWithTitleProps
    }
    items {
      title
      richContent {
        value
      }
    }
    special
  }
}
`